import { render } from "./FooterSide.vue?vue&type=template&id=6fd3d338"
import script from "./FooterSide.vue?vue&type=script&lang=js"
export * from "./FooterSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__